// extracted by mini-css-extract-plugin
export default {"newsItemOpas":"OpasNewsLetterBox_newsItemOpas__eGXwX","releaseData":"OpasNewsLetterBox_releaseData__i6vPs"};